<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">Admin Console</el-breadcrumb-item>
                <el-breadcrumb-item>Manage Customer</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="16">
                <div class="main-title">
                    Manage Customer
                </div>

            </el-col>
            <el-col :span="8" class="text-right">

            </el-col>
        </el-row>
        <el-card class="box-card mt-6" v-loading="loading">
            <div slot="header" class="clearfix">
                <span>Customer Detail</span>
            </div>
            <div class="text item" >
                <el-table
                        :show-header="false"
                        :data="detailData"
                        style="width: 100%">
                    <el-table-column
                            label="key"
                            align="right"
                            class-name="font-bold">
                            <template slot-scope="scope" >
                                <span class="mr-6">{{scope.row.key}}</span>
                            </template>
                    </el-table-column>
                    <el-table-column
                            prop="value"
                            label="Value">
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <el-tabs class="mt-6">
            <el-tab-pane v-loading="loadingDevices">
                <span slot="label"><strong>Owned Devices</strong></span>
                <div style="margin-top: 12px">
                    <el-row style="margin-bottom: 18px">
                        <el-col style="text-align: end">
                            <el-button type="warning" size="small" @click="assignDevice()">Assign Device</el-button>
                        </el-col>
                    </el-row>
                    <el-card class="box-card" style="margin-top: 24px">
                        <el-table
                                :data="ownedDevices">
                            <el-table-column
                                    property="id"
                                    label="Id"
                                    width="50"/>
                            <el-table-column
                                    property="firstName"
                                    label="First Name"
                                    width="120"/>
                            <el-table-column
                                    property="lastName"
                                    label="lastName"
                                    width="150"/>
                            <el-table-column
                                    property="deviceID"
                                    label="Device ID"
                                    width="180"/>
                            <el-table-column
                                    property="contractNumber"
                                    label="Contract/Order No."
                                    width="180"/>
                            <el-table-column
                                    property="registered"
                                    label="Registered" 
                                    width="150">
                                    <template slot-scope="scope">
                                        <i :class="{'text-xl el-icon-check text-green' : scope.row.registered, 'text-xl el-icon-close text-red' : !scope.row.registered}"></i>
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    property="retailCountryCode"
                                    label="Retail Country Code"
                                    width="120"/>
                            <el-table-column
                                    property="country"
                                    label="GSR Country"
                                    width="120"/>
                            <el-table-column
                                    property="userCountryName"
                                    label="User Country"
                                    width="120"/>
                            <el-table-column
                                    property="city"
                                    label="City"
                                    width="200"/>
                            <el-table-column
                                    property="mobileNumber"
                                    label="Mobile Number" 
                                    width="150"/>
                            <el-table-column
                                    property="resetPasswordEmail"
                                    label="Reset Password Email" 
                                    min-width="250"/>
                            <el-table-column
                                    property="hasReset"
                                    label="Reset Pw Flag" 
                                    width="150">
                                    <template slot-scope="scope">
                                        <i :class="{'text-xl el-icon-check text-green' : scope.row.hasReset, 'text-xl el-icon-close text-red' : !scope.row.hasReset}"></i>
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    label="Reset Flag Expiry" 
                                    width="200">
                                    <template slot-scope="scope" >
                                        {{scope.row.resetExpiry | formatDateTime}}
                                    </template>
                            </el-table-column>
                            <el-table-column
                                    fixed="right"
                                    label="Operations"
                                    align="center"
                                    width="400">
                                <template slot-scope="scope">
                                    <el-button slot="reference" size="mini" type="danger" @click.stop="confirmRepossessDevice(scope.$index, scope.row)">Repossess</el-button>
                                    <el-button
                                        size="mini"
                                        @click="confirmResetDevicePassword(scope.$index, scope.row)">
                                        Reset Password
                                    </el-button>
                                    <el-button
                                        size="mini"
                                        type="warning"
                                        @click="startEditContractNumber(scope.$index, scope.row)">
                                        Edit Contract No.
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </el-tab-pane>
            <el-tab-pane v-loading="loadingRepoDevices">
                <span slot="label"><strong>Returned Devices</strong></span>
                <div style="margin-top: 12px">
                    <el-card class="box-card" style="margin-top: 24px">
                        <el-table
                                :data="repoDevices">
                            <el-table-column
                                    property="id"
                                    label="Id"
                                    width="50"/>
                            <el-table-column
                                    property="firstName"
                                    label="First Name"
                                    width="120"/>
                            <el-table-column
                                    property="lastName"
                                    label="lastName"
                                    width="150"/>
                            <el-table-column
                                    property="deviceID"
                                    label="Device ID"
                                    width="180"/>
                            <el-table-column
                                    property="deviceState"
                                    label="Device State"
                                    width="180"/>
                            <el-table-column
                                    property="registrationCode"
                                    label="Registration Code"
                                    width="150" />
                            <el-table-column
                                    property="country"
                                    label="Country"
                                    width="120"/>
                            <el-table-column
                                    property="city"
                                    label="City"
                                    width="200"/>
                            <el-table-column
                                    property="mobileNumber"
                                    label="Mobile Number" 
                                    width="150"/>
                            <el-table-column
                                    fixed="right"
                                    label="Operations"
                                    align="center"
                                    width="260">
                                <template slot-scope="scope">
                                    <!-- <el-popover
                                            class="mr-4"
                                            :ref="'givaback_popover'+scope.$index"
                                            placement="top"
                                            width="200"
                                            v-model="scope.row.confirmGiveBack">
                                        <p class="mb-3">Give Back Device?</p>
                                        <div style="text-align: right; margin: 0">
                                            <el-button size="mini" type="text" @click.stop="scope.row.confirmGiveBack = false">cancel</el-button>
                                            <el-button type="primary" size="mini" @click.stop="scope.row.confirmGiveBack = false; giveBackDevice(scope.$index, scope.row)">confirm</el-button>
                                        </div>
                                        
                                    </el-popover> -->
                                    <el-button slot="reference" size="mini" type="success" @click.stop="confirmGiveBackDevice(scope.$index, scope.row)" :disabled="scope.row.deviceState === 'OWNED'">Give Back</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="Assign Device" :visible.sync="showAssignDialog" >
            <div v-loading="loadingAvailableDevice">
                <el-table
                        :data="availableDevices"
                        style="width: 100%;"
                        @row-click="availableDeviceClicked">
                    <el-table-column
                            property="deviceID"
                            label="Device ID"
                            width="180"/>
                    <el-table-column
                            property="registrationCode"
                            label="Registration Code"
                            width="150"/>
                    <el-table-column
                            property="lastOwner.email"
                            label="Last Owner"
                            width="200"/>
                    <el-table-column
                            property="state"
                            label="Status"
                            width="150"/>
                </el-table>

                <pagination v-show="availableDeviceQuery.total>0" :total="availableDeviceQuery.total" :page.sync="availableDeviceQuery.page" :limit.sync="availableDeviceQuery.limit" @pagination="loadAvailableDevices" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showAssignDialog = false">Cancel</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="deviceStateChangeDialogTitle" :visible.sync="showDeviceStateChangeDialog" >
            <div v-loading="saving">
                <p style="word-break: normal">{{deviceStateChangeType}} Device with ID: <b>{{editingDevice.deviceID}}</b>?</p>
                <el-divider/>
                <el-form :model="editingDevice" ref="deviceForm" >

                    <el-form-item label="Comment" >
                        <el-input type="textarea" v-model="editingDevice.comment"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDeviceStateChangeDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="doEditDevice()">Submit</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Reset Parent Mode Password" :visible.sync="showDeviceResetPWDialog" >
            <div v-loading="saving">
                <p style="word-break: normal">Reset Parent Mode Password for Device with ID: <b>{{editingDevice.deviceID}}</b>?</p>
                
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDeviceResetPWDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="doResetDevicePassword()">Submit</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Update Contract/Order Number" :visible.sync="showDeviceUpdateContractDialog" >
            <div v-loading="saving">
                <p style="word-break: normal; text-align: center">Updating Contract/Order Number for Device with ID: <b>{{editingDevice.deviceID}}</b></p>
            </div>
            
            <el-form style="margin-top: 32px" :model="contractFormData" ref="contractForm" :rules="contractRules">
                <el-form-item :required="true" label-width="250px" label="New Contract/Order Number" prop="contractNumber">
                    <el-input  size="small" v-model="contractFormData.contractNumber"></el-input>
                </el-form-item>
            </el-form>
            <span v-loading="saving" slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDeviceUpdateContractDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="doEditContractNumber()">Submit</el-button>
            </span>
        </el-dialog>
        <pair-device v-model="pairForm" :enter-email="false" v-on:submit-form="doPairDevice"/>
    </el-main>
</template>

<script>
import Pagination from "@/components/Pagination"
import _ from 'lodash'
import api from '@/services/api/WRCService'
import pairDevice from "@/components/PairDevice"
import moment from 'moment'

export default {
    props: ['customerId'],
    components: { 
        Pagination,
        pairDevice
    },
    data: function() {
        var validateContractNumber = (rule, value, callback) => {
            if (!value || value == '') {
                callback(new Error('Please enter Contract Number'));
            } else {
                let isnum = /^\d+$/.test(value);

                if (!isnum) {
                    callback(new Error('Contract Number can only contains number 0-9'));
                } else if (value.length < 6 || value.length > 8) {
                    callback(new Error('Contract Number length must be in between 6-8 characters'));
                }

                callback();
            }
        };

        return {
            contractRules: {
                contractNumber: [
                    { validator: validateContractNumber, trigger: 'change' }
                ],
            },
            saving: false,
            loading: false,
            loadingDevices: false,
            loadingRepoDevices: false,
            loadingAvailableDevice: false,
            showAssignDialog: false,
            showDeviceStateChangeDialog: false,
            showDeviceResetPWDialog: false,
            showDeviceUpdateContractDialog: false,
            contractFormData: {},
            deviceStateChangeType: "REPOSSESS",
            deviceStateChangeDialogTitle: "Repossess Device",
            editingDevice: {},
            detailData: [],
            customer: {},
            pairForm: {
                show: false,
            },
            availableDeviceQuery: {
                total: 3,
                page: 1,
                limit: 10
            },
            multipleSelection: [],
            customers: [],
            ownedDevices: [],
            repoDevices: [],
            availableDevices: []
        }
    },
    methods: {
        loadDevices() {
            this.loadingDevices = true
            this.loadingRepoDevices = true

            api.getCustomerDevices(this.customerId, 'ACTIVE', {
                page: 0,
                size: 100
            }).then(({ data }) => {

                this.ownedDevices.splice(0, this.ownedDevices.length)
                this.ownedDevices.push(...data.data.items)
                this.ownedDevices.total = data.data.pagination.totalRecords

            }).catch(() => {}).then(() => {
                this.loadingDevices = false;
            });

            api.getCustomerDevices(this.customerId, 'REPOSSESSED', {
                page: 0,
                size: 100
            }).then(({ data }) => {

                this.repoDevices.splice(0, this.repoDevices.length)
                this.repoDevices.push(...data.data.items)
                this.repoDevices.total = data.data.pagination.totalRecords

            }).catch(() => {}).then(() => {
                this.loadingRepoDevices = false
            });
        },
        loadAvailableDevices() {
            this.loadingAvailableDevice = true;

            api.getAvailableDevices(null, null, null, {
                page: this.availableDeviceQuery.page - 1,
                size: this.availableDeviceQuery.limit
            }).then(({ data }) => {

                this.availableDevices.splice(0, this.availableDevices.length);
                this.availableDevices.push(...data.data.items);
                this.availableDeviceQuery.total = data.data.pagination.totalRecords;

            }).catch(() => {}).then(() => {
                this.loadingAvailableDevice = false;
            });
        },
        assignDevice() {
            this.loadAvailableDevices()
            this.showAssignDialog = true
        },
        availableDeviceClicked(row, column, event) {
            if (row.lastOwner.email === this.customer.email) {

                this.pairForm = {
                    show: true,
                    deviceID: row.deviceID,
                    firstName: row.lastOwner.firstName,
                    lastName: row.lastOwner.lastName,
                    city: row.lastOwner.city,
                    mobileNo: row.lastOwner.mobileNumber,
                    contractNumber: row.lastOwner.contractNumber,
                    country: {
                        id: row.lastOwner.countryId,
                        name: row.lastOwner.country,
                        code: row.lastOwner.countryCode
                    },
                    resetEmail: row.lastOwner.resetPasswordEmail,
                }

                if (row.lastOwner.userCountryName != null) {
                    this.pairForm.userCountry = {
                        country: row.lastOwner.userCountryName,
                        abbreviation: row.lastOwner.userCountryCode
                    }
                }
            } else {
                this.pairForm = {
                    show: true,
                    deviceID: row.deviceID
                }
            }
        },
        doPairDevice() {
            this.pairForm.show = false

            var param = {
                email: this.customer.email,
                parentModePasswordResetEmail: this.pairForm.resetEmail,
                deviceID: this.pairForm.deviceID,
                firstName: this.pairForm.firstName,
                lastName: this.pairForm.lastName,
                gsrCountryId: this.pairForm.country.id,
                retailCountryCode: this.pairForm.country.code,
                userCountryName: this.pairForm.userCountry.country,
                userCountryCode: this.pairForm.userCountry.abbreviation,
                city: this.pairForm.city,
                contactNumber: this.pairForm.mobileNo,
                contractNumber: this.pairForm.contractNumber,
                comment: this.pairForm.comment,
            }

            this.loadingAvailableDevice = true

            api.pairDevice(param)
            .then(({ data }) => {

                this.$message({
                    message: 'Assigned device.',
                    type: 'success'
                });

                this.loadDevices()
                this.showAssignDialog = false

            }).catch(() => {
                
            }).then(() => {
                this.loadingAvailableDevice = false
            });
        },
        confirmResetDevicePassword(index, device) {
            this.editingDevice = device
            this.showDeviceResetPWDialog = true
        },
        confirmRepossessDevice(index, device) {
            this.editingDevice = device
            this.deviceStateChangeType = "Repossess"
            this.deviceStateChangeDialogTitle = "Repossess Device"
            this.showDeviceStateChangeDialog = true
        },
        confirmGiveBackDevice(index, device) {
            this.editingDevice = device
            this.deviceStateChangeType = "Give Back"
            this.deviceStateChangeDialogTitle = "Give Back Device"
            this.showDeviceStateChangeDialog = true
        },
        startEditContractNumber(index, device) {
            this.editingDevice = device
            this.contractFormData = {}
            this.showDeviceUpdateContractDialog = true

            setTimeout(() => {
                if (!_.isUndefined(this.$refs['contractForm'])) {
                    this.$refs['contractForm'].clearValidate();
                }
            }, 1);
        },
        doEditContractNumber() {
            this.$refs['contractForm'].validate((valid) => {
                if (valid) {
                    this.saving = true

                    api.updateDeviceContractNumber(this.customerId, this.editingDevice.id, this.contractFormData.contractNumber, null)
                    .then(({ data }) => {

                        this.$message({
                            message: 'Updated Contract/Order Number.',
                            type: 'success'
                        });

                        this.loadDevices()

                        this.showDeviceUpdateContractDialog = false

                    }).catch(() => {

                    }).then(() => {
                        this.saving = false
                    });
                }
            })
        },
        doResetDevicePassword() {
            this.saving = true

            api.resetCustomerDeviceParentModePassword(this.customerId, this.editingDevice.id)
            .then(({ data }) => {

                this.$message({
                    message: 'Reset Parent Mode password flag turned on.',
                    type: 'success'
                });

                this.loadDevices()

                this.showDeviceResetPWDialog = false

            }).catch(() => {

            }).then(() => {
                this.saving = false
            });
        },
        doEditDevice() {
            if (this.deviceStateChangeType === "Repossess") {
                this.repossessDevice()
            } else {
                this.giveBackDevice()
            }
        },
        repossessDevice() {
            this.saving = true

            api.repossessCustomerDevice(this.customerId, this.editingDevice.id, this.editingDevice.comment)
            .then(({ data }) => {

                this.$message({
                    message: 'Repossessed device.',
                    type: 'success'
                });

                this.loadDevices()

                this.showDeviceStateChangeDialog = false

            }).catch(() => {

            }).then(() => {
                this.saving = false
            });
        },
        giveBackDevice() {
            this.saving = true

            api.giveBackCustomerDevice(this.customerId, this.editingDevice.id, this.editingDevice.comment)
            .then(({ data }) => {

                this.$message({
                    message: 'Gave back device.',
                    type: 'success'
                });

                this.loadDevices()

                this.showDeviceStateChangeDialog = false

            }).catch(() => {

            }).then(() => {
                this.saving = false
            });
        }
    },
    mounted() {
        if (!_.isUndefined(this.customerId)) {
            this.loading = true

            api.getCustomer(this.customerId).then(({data}) =>{
                this.customer = data.data

                this.detailData = [
                    { key: "Email", value: this.customer.email},
                    { key: "Joined Date", value: moment(this.customer.createdDate).format('DD-MMM-YYYY')}
                ]
            }).catch(() => {}).then(() => {
                this.loading = false
            })

            this.loadDevices();
        }
    },
}
</script>
